import React from 'react'
import echarts, { EChartOption } from 'echarts/lib/echarts'
import ReactEchartsCore from 'echarts-for-react/lib/core'
import { ArticleListData } from 'sdss/types/ListArticlesModules'
import { processing, relationNode } from './KnowledgeGraphApi'
import 'echarts/lib/chart/graph'
import 'echarts/lib/component/tooltip'

export interface KGNode {
    id: string,
    name: string,
    symbolSize: number,
    itemStyle: {
        color?: string,
        opacity?: number,
    },
    treenumber?: string,
}

export interface StringColors {
    [index: string]: string;
}

interface ArticleListDataProps {
    graphData: ArticleListData
}

export function KnowledgeGraph(params: ArticleListDataProps) {
    // 指定图表的配置项和数据(为每个点增加 type 和 level 属性，并根据此生成颜色)
    const colors: StringColors = { A: '#5B7FF9', B: '#F6C61B', C: '#48C07A', D: '#F45C6A', E: '#F1951D', F: '#3BB7ED', G: '#6662FF', N: '#FF4F9C' }
    let graphData = params
    let correctedWord = graphData.graphData.corrected_word
    let treenumberList = graphData.graphData.treenumber_list
    let data = processing(correctedWord, treenumberList)
    let links = relationNode(data)

    const calcColor = (node: KGNode) => {
        if (node.treenumber) {
            const type = node.treenumber[0]
            node.itemStyle.color = colors[type] ? colors[type] : '#5B9CF9'
            if (node.treenumber.length > 1) {
                const level = node.treenumber.split('.').length + 2
                const opacity = 1 - (level - 1) * 0.08
                node.itemStyle.opacity = opacity < 0.36 ? 0.36 : opacity
            }
        }
    }

    data.forEach((node: KGNode) => calcColor(node))
    const option: EChartOption = {
        series: [{
            data: data,
            layout: 'force',
            symbol: 'circle',
            roam: true,
            focusNodeAdjacency: true,
            hoverAnimation: true,
            label: {
                show: true,
                formatter: '{b}',
                color: '#999',
                fontSize: 14,
                position: 'top'
            },
            type: 'graph',
            links,
            lineStyle: {
                color: 'source'
            },
            draggable: true,
            edgeSymbol: ['arrow', 'arrow'],
            edgeSymbolSize: 0,
            force: {
                initLayout: 'circular',
                repulsion: [150, 200],
                edgeLength: [30, 50],
                gravity: 0.07,
                layoutAnimation: true,
            }
        }],
        tooltip: {
            trigger: 'item',
            formatter(params:any) {    // echarts关系图自身没有判断dataType的ts，暂时用any
                if (params.dataType !== 'edge') {
                    if (params.data.symbolSize === 60) {
                        return `搜索词：${correctedWord}`
                    } else if (params.data.treenumber.length === 1) {
                        return '分类：' + params.data.name
                    } else {
                        return `关键词：${params.data.name}（前100篇中有${params.data.count}篇提及）`
                    }
                } else {
                    return ''
                }
            }
        }
    }

    return (
        <div>
            <ReactEchartsCore
                echarts={echarts}
                option={option}
                notMerge={true}
                style={{ height: '600px' }}
                lazyUpdate={true}
            />
            <div style={{ margin: '10px 0', textAlign: 'center' }}>
                <span style={{ display: 'inline-block', width: 7, height: 7, borderRadius: '50%', backgroundColor: '#276ed5' }}></span>
                <span style={{ color: '#999', marginLeft: 10 }}>节点的大小代表了文献数量的多少，节点越大，文献越多</span>
            </div>
        </div>
    )
}
